import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';

const ListHeader = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 20px 0 14px 15px;
  align-items: center;
`;

const LeftHeader = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderTitle = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.5px;
`;

type IncentiveScrappingListHeaderProps = {
  isMultipleSelection: boolean;
  allVisibleSelected: boolean;
  onToggleAllVisible: () => void;
};

const IncentiveScrappingListHeader = ({
  isMultipleSelection,
  allVisibleSelected,
  onToggleAllVisible,
}: IncentiveScrappingListHeaderProps) => {
  return (
    <ListHeader>
      <LeftHeader>
        {isMultipleSelection && (
          <Checkbox checked={allVisibleSelected} onChange={onToggleAllVisible} style={{ marginRight: '15px' }} />
        )}
        <HeaderTitle>COMPANY</HeaderTitle>
      </LeftHeader>
    </ListHeader>
  );
};

export default IncentiveScrappingListHeader;
